import React from 'react';
import CashBook from '../components/CashBook';

const CashBookPage = () => {
  return (
    <div className="p-4 sm:p-6 md:p-8 lg:p-12">
      <CashBook />
    </div>
  );
};

export default CashBookPage;
